import {CONFIG} from "../../config";
import axios from "axios";

async function MeQuery() {
    const location = CONFIG.API_URL + "user/me";
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default MeQuery;